(function () {
  var LIMITED_PRODUCT_ID = 15755376984438;

  // Inject styles once
  var style = document.createElement('style');
  style.textContent = [
    '.product-form__submit.qty-limit-reached,',
    '.quick-add__submit.qty-limit-reached { opacity: 0.5; cursor: not-allowed; }',
    '.qty-limit-msg { margin-top: 0.8rem; font-size: 1.3rem; color: #EB001B;',
    '  line-height: 1.4; letter-spacing: 0.04rem; }',
  ].join(' ');
  document.head.appendChild(style);

  // ── Quantity input locking ────────────────────────────────────────────────

  // Forces min=1, max=1, value=1 and re-validates buttons.
  // Called on init and after every quantityUpdate so that product-info.js
  // setQuantityBoundries() (which computes max = data-max - cartQty = 0) cannot
  // override our locked state.
  function enforceLockedInputState(input) {
    input.min = '1';
    input.max = '1';
    if (parseInt(input.value) !== 1) {
      input.value = '1';
    }
    var qtyEl = input.closest('quantity-input');
    if (qtyEl && typeof qtyEl.validateQtyRules === 'function') {
      qtyEl.validateQtyRules();
    }
  }

  function handleLockedInput(input) {
    if (input._qtyLocked) return;
    input._qtyLocked = true;

    enforceLockedInputState(input);

    input.addEventListener('input', function () {
      input.setCustomValidity('');
    });

    input.addEventListener('change', function (e) {
      var val = parseInt(input.value);
      if (isNaN(val) || val < 1) {
        e.stopImmediatePropagation();
        input.value = 1;
        return;
      }
      if (val > 1) {
        e.stopImmediatePropagation();
        input.value = 1;
        input.setCustomValidity('Maksymalna ilość tego produktu to 1');
        input.reportValidity();
        setTimeout(function () {
          input.setCustomValidity('');
        }, 3000);
      }
    });
  }

  function initLockedInputs() {
    document.querySelectorAll('input[data-qty-locked]').forEach(handleLockedInput);
  }

  // ── Add-to-cart limit (product page + collection cards) ──────────────────

  function getAllProductFormEls() {
    return document.querySelectorAll(
      'product-form[data-product-id="' + LIMITED_PRODUCT_ID + '"]'
    );
  }

  function getLimitMsgEl(productFormEl) {
    var anchor = productFormEl.closest('.buy-wrapper') || productFormEl.parentElement;
    var sibling = anchor.nextElementSibling;
    if (sibling && sibling.classList.contains('qty-limit-msg')) {
      return sibling;
    }
    var msgEl = document.createElement('p');
    msgEl.className = 'qty-limit-msg';
    msgEl.setAttribute('hidden', '');
    anchor.parentElement.insertBefore(msgEl, anchor.nextSibling);
    return msgEl;
  }

  function showLimitError(productFormEl) {
    var msgEl = getLimitMsgEl(productFormEl);
    msgEl.textContent = 'Posiadasz maksymalną ilość tego produktu w koszyku';
    msgEl.removeAttribute('hidden');
    setTimeout(function () {
      msgEl.setAttribute('hidden', '');
    }, 4000);
  }

  function applyButtonState(isReached) {
    getAllProductFormEls().forEach(function (productFormEl) {
      var btn = productFormEl.querySelector('button[type="submit"]');
      if (!btn) return;

      if (isReached) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('qty-limit-reached');
      } else {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('qty-limit-reached');
      }

      if (!btn._limitClickInited) {
        btn._limitClickInited = true;
        var isCardContext = !!productFormEl.closest('.quick-add');
        btn.addEventListener('click', function () {
          if (btn.classList.contains('qty-limit-reached') && !isCardContext) {
            showLimitError(productFormEl);
          }
        });
      }
    });
  }

  function checkCartAndUpdateButton() {
    if (getAllProductFormEls().length === 0) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items.some(function (item) {
          return item.product_id === LIMITED_PRODUCT_ID;
        });
        applyButtonState(inCart);
      })
      .catch(function () {});
  }

  // ── Initialisation ───────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    initLockedInputs();
    checkCartAndUpdateButton();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // After any cart update: re-check button state and re-lock inputs
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(initLockedInputs, 200);
        setTimeout(checkCartAndUpdateButton, 300);
      });

      // After product-info.js setQuantityBoundries() recalculates the input
      // (it publishes quantityUpdate), restore our locked state.
      // setTimeout(0) ensures we run after QuantityInput's own validateQtyRules
      // subscriber (which was registered earlier).
      subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
        setTimeout(function () {
          document.querySelectorAll('input[data-qty-locked]').forEach(enforceLockedInputState);
        }, 0);
      });
    }

    var cartDrawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (cartDrawerInner) {
      new MutationObserver(initLockedInputs).observe(cartDrawerInner, {
        childList: true,
        subtree: true,
      });
    }
  });
})();
